export class SensitivityCategorization {
  sensitivityCategorizationId?: number;
  clientITProfileId?: number;
  informationType?: string;
  identifier?: string;
  confidentiality?: number;
  integrity?: number;
  availability?: number;
}
